import { useCallback } from 'react';
import { FORM_ERROR } from 'final-form';

import * as helpers from './helpers';

// Wrap onSubmit to handle global form error and allow formatting data before submit
export const useOnSubmitWrapped = ({ onSubmit, formatData, fieldsToReplaceComma }) => {
    return useCallback(async (values, ...args) => {
        const valuesWithoutComma = helpers.formatFieldsWithComma(values, fieldsToReplaceComma);
        const formattedValues = formatData ? formatData(valuesWithoutComma, ...args) : valuesWithoutComma;
        const result = await onSubmit(formattedValues, ...args);

        return result == null || result instanceof Object ? result : { [FORM_ERROR]: result };

    }, [formatData, onSubmit, fieldsToReplaceComma]);
};
